import script from "./RecommendOrderField.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendOrderField.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendOrderField.vue?vue&type=style&index=0&id=41fa8c2e&lang=scss&scoped=true"
import "./RecommendOrderField.vue?vue&type=style&index=1&id=41fa8c2e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41fa8c2e"]])

export default __exports__